import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'// svg component

// register globally
Vue.component('svg-icon', SvgIcon)

const req = require.context('./svg', true, /\.svg$/)
// require.context('./svg', false, /\.svg$/) 有时候我们需要一次性的引入某个文件夹下的所有文件，那么这个时候就可以使用require.context()来完成。
// ./svg：需要引入文件的目录
// true：是否查找该目录下的子级目录
// /\.svg$/：匹配引入文件的正则表达式
const requireAll = requireContext => requireContext.keys().map(requireContext)
requireAll(req)
